<template>
  <div class="row">
    <div class="col-md-12 col-xs-12">
      <meeting-meta v-model="meetingMeta" @is-valid="e => meetingMetaValid = e"></meeting-meta>
    </div>
    <div class="col-md-12 col-xs-12">
      <meeting-form-builder v-if="meetingMeta.hasForm"
        v-model="meetingForm"
        @is-valid="e => meetingFormValid = e"
      ></meeting-form-builder>
    </div>
    <div class="action-container col-md-12">
      <button class="submit-button btn btn-success save-button"
        :disabled="!validMeeting || creatingMeeting"
        @click="addMeeting">
        <i class="fa fa-spinner fa-spin" v-if="creatingMeeting" aria-hidden="true"></i>
        Create Meeting
      </button>
      <br/>
    </div>
  </div>
</template>

<style scoped>
.row {
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
}

.row > div.col-md-12 {
  padding: 0;
}

section h2 {
  margin-top: 0;
  margin-bottom: 25px;
}

.form-group small {
  font-style: italic;
}

.meeting-form-container {
  display: flex;
  flex-direction: column;
  padding-bottom: 15px;
}

.meeting-form-container form {
  margin-left: -15px;
}

.meeting-description label,
.meeting-details label {
  width: 100%;
}

.meeting-details {
  padding-top: 15px;
}

.action-container {
  text-align: right;
  margin-top: 10px;
}
</style>

<script>

import MeetingMeta from './meeting-meta.vue';
import MeetingFormBuilder from './meeting-form-builder.vue';

export default {

  components: {
    MeetingFormBuilder,
    MeetingMeta,
  },

  data() {
    return {
      creatingMeeting: false,
      meetingMeta: {
        title: '',
        description: '',
        meetingTags: [],
        hasForm: false,
        supportFunction: 'coach',
        requiresLearnerSignature: true,
        shareWithEmployerDefault: true,
      },
      meetingForm: {
        prompts: [],
        reviewType: '',
        description: '',
      },
      meetingFormValid: false,
      meetingMetaValid: false,
    };
  },

  computed: {
    validMeeting() {
      if (this.meetingMeta.hasForm) {
        return this.meetingMetaValid && this.meetingFormValid;
      }
      return this.meetingMetaValid;
    },
  },

  methods: {
    createMeetingRequest() {
      const payload = {
        name: this.meetingMeta.title,
        description: this.meetingMeta.description,
        tags: this.meetingMeta.meetingTags,
        is_progress_review: this.meetingMeta.hasForm,
        support_function: this.meetingMeta.supportFunction || 'coach',
        is_adhoc: this.meetingMeta.isAdhoc || false,
        requires_learner_signature: this.meetingMeta.requiresLearnerSignature ?? true,
        share_with_employer_default: this.meetingMeta.shareWithEmployerDefault ?? true,
      };
      this.$logger.info('Adding Meeting', { payload }, true);
      return this.$http.post('/api/curriculum/admin/meeting', payload);
    },
    createMeetingFormRequest(meetingId) {
      const meetingFormPayload = {
        meeting_id: meetingId,
        review_type: this.meetingForm.reviewType,
        description: this.meetingForm.description,
        prompts: this.meetingForm.prompts.map((p, i) => ({
          id: p.id || null,
          prompt: p.prompt,
          response_type: p.responseType,
          review_type: p.reviewType,
          answers: p.responseType === 'MULTIPLE_CHOICE' ? p.answers : null,
          number: i + 1,
        })),
      };
      this.$logger.info('Creating meeting form', { meetingFormPayload });
      return this.$http.post('/api/curriculum/admin/meeting/form', meetingFormPayload);
    },
    addMeeting() {
      let meetingId;
      const hasForm = this.meetingMeta.hasForm;
      this.creatingMeeting = true;
      this.$Loading.start();
      this.createMeetingRequest()
        .catch(error => {
          this.$logger.error('Error posting to meeting db', { }, error);
          this.$ktoast.showError(error);
          throw error;
        })
        .then(res => {
          meetingId = res.data.meeting_id;
          this.$ktoast.success('New Meeting Created');
          if (hasForm) {
            return this.createMeetingFormRequest(meetingId)
              .catch(error => {
                this.$logger.error('Error posting to meeting form db', { meetingId }, error);
                this.$ktoast.showError(error);
                throw error;
              });
          }
          return Promise.resolve();
        })
        .then(() => {
          this.$emit('meeting-added');
          this.$emit('update');
          this.clearFields();
        })
        .catch(error => {
          this.$logger.error('Error creating meeting', { meetingId }, error);
        })
        .finally(() => {
          this.creatingMeeting = false;
          this.$Loading.finish();
        });
    },

    clearFields() {
      this.meetingMeta = {
        title: '',
        description: '',
        meetingTags: [],
        hasForm: false,
        supportFunction: null,
        requiresLearnerSignature: true,
        shareWithEmployerDefault: true,
      };
      this.meetingForm = {
        prompts: [],
        reviewType: '',
        description: '',
      };
    },
  },
};
</script>
